/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.MessageBody = (function() {

    /**
     * Properties of a MessageBody.
     * @exports IMessageBody
     * @interface IMessageBody
     * @property {MessageBody.DataType|null} [dataType] MessageBody dataType
     * @property {string|null} [mid] MessageBody mid
     * @property {IHeartbeat|null} [heartbeat] MessageBody heartbeat
     * @property {IEBoxInfo|null} [eBoxInfo] MessageBody eBoxInfo
     * @property {IEBoxInfoList|null} [eBoxInfoList] MessageBody eBoxInfoList
     * @property {IAlarmEvent|null} [alarmEvent] MessageBody alarmEvent
     */

    /**
     * Constructs a new MessageBody.
     * @exports MessageBody
     * @classdesc Represents a MessageBody.
     * @implements IMessageBody
     * @constructor
     * @param {IMessageBody=} [properties] Properties to set
     */
    function MessageBody(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MessageBody dataType.
     * @member {MessageBody.DataType} dataType
     * @memberof MessageBody
     * @instance
     */
    MessageBody.prototype.dataType = 0;

    /**
     * MessageBody mid.
     * @member {string} mid
     * @memberof MessageBody
     * @instance
     */
    MessageBody.prototype.mid = "";

    /**
     * MessageBody heartbeat.
     * @member {IHeartbeat|null|undefined} heartbeat
     * @memberof MessageBody
     * @instance
     */
    MessageBody.prototype.heartbeat = null;

    /**
     * MessageBody eBoxInfo.
     * @member {IEBoxInfo|null|undefined} eBoxInfo
     * @memberof MessageBody
     * @instance
     */
    MessageBody.prototype.eBoxInfo = null;

    /**
     * MessageBody eBoxInfoList.
     * @member {IEBoxInfoList|null|undefined} eBoxInfoList
     * @memberof MessageBody
     * @instance
     */
    MessageBody.prototype.eBoxInfoList = null;

    /**
     * MessageBody alarmEvent.
     * @member {IAlarmEvent|null|undefined} alarmEvent
     * @memberof MessageBody
     * @instance
     */
    MessageBody.prototype.alarmEvent = null;

    // OneOf field names bound to virtual getters and setters
    var $oneOfFields;

    /**
     * MessageBody dataBody.
     * @member {"heartbeat"|"eBoxInfo"|"eBoxInfoList"|"alarmEvent"|undefined} dataBody
     * @memberof MessageBody
     * @instance
     */
    Object.defineProperty(MessageBody.prototype, "dataBody", {
        get: $util.oneOfGetter($oneOfFields = ["heartbeat", "eBoxInfo", "eBoxInfoList", "alarmEvent"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new MessageBody instance using the specified properties.
     * @function create
     * @memberof MessageBody
     * @static
     * @param {IMessageBody=} [properties] Properties to set
     * @returns {MessageBody} MessageBody instance
     */
    MessageBody.create = function create(properties) {
        return new MessageBody(properties);
    };

    /**
     * Encodes the specified MessageBody message. Does not implicitly {@link MessageBody.verify|verify} messages.
     * @function encode
     * @memberof MessageBody
     * @static
     * @param {IMessageBody} message MessageBody message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MessageBody.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.dataType != null && Object.hasOwnProperty.call(message, "dataType"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.dataType);
        if (message.mid != null && Object.hasOwnProperty.call(message, "mid"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.mid);
        if (message.heartbeat != null && Object.hasOwnProperty.call(message, "heartbeat"))
            $root.Heartbeat.encode(message.heartbeat, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.eBoxInfo != null && Object.hasOwnProperty.call(message, "eBoxInfo"))
            $root.EBoxInfo.encode(message.eBoxInfo, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.eBoxInfoList != null && Object.hasOwnProperty.call(message, "eBoxInfoList"))
            $root.EBoxInfoList.encode(message.eBoxInfoList, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.alarmEvent != null && Object.hasOwnProperty.call(message, "alarmEvent"))
            $root.AlarmEvent.encode(message.alarmEvent, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified MessageBody message, length delimited. Does not implicitly {@link MessageBody.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MessageBody
     * @static
     * @param {IMessageBody} message MessageBody message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MessageBody.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MessageBody message from the specified reader or buffer.
     * @function decode
     * @memberof MessageBody
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MessageBody} MessageBody
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MessageBody.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MessageBody();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.dataType = reader.int32();
                break;
            case 2:
                message.mid = reader.string();
                break;
            case 3:
                message.heartbeat = $root.Heartbeat.decode(reader, reader.uint32());
                break;
            case 4:
                message.eBoxInfo = $root.EBoxInfo.decode(reader, reader.uint32());
                break;
            case 5:
                message.eBoxInfoList = $root.EBoxInfoList.decode(reader, reader.uint32());
                break;
            case 6:
                message.alarmEvent = $root.AlarmEvent.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MessageBody message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MessageBody
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MessageBody} MessageBody
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MessageBody.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MessageBody message.
     * @function verify
     * @memberof MessageBody
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MessageBody.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        var properties = {};
        if (message.dataType != null && message.hasOwnProperty("dataType"))
            switch (message.dataType) {
            default:
                return "dataType: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.mid != null && message.hasOwnProperty("mid"))
            if (!$util.isString(message.mid))
                return "mid: string expected";
        if (message.heartbeat != null && message.hasOwnProperty("heartbeat")) {
            properties.dataBody = 1;
            {
                var error = $root.Heartbeat.verify(message.heartbeat);
                if (error)
                    return "heartbeat." + error;
            }
        }
        if (message.eBoxInfo != null && message.hasOwnProperty("eBoxInfo")) {
            if (properties.dataBody === 1)
                return "dataBody: multiple values";
            properties.dataBody = 1;
            {
                var error = $root.EBoxInfo.verify(message.eBoxInfo);
                if (error)
                    return "eBoxInfo." + error;
            }
        }
        if (message.eBoxInfoList != null && message.hasOwnProperty("eBoxInfoList")) {
            if (properties.dataBody === 1)
                return "dataBody: multiple values";
            properties.dataBody = 1;
            {
                var error = $root.EBoxInfoList.verify(message.eBoxInfoList);
                if (error)
                    return "eBoxInfoList." + error;
            }
        }
        if (message.alarmEvent != null && message.hasOwnProperty("alarmEvent")) {
            if (properties.dataBody === 1)
                return "dataBody: multiple values";
            properties.dataBody = 1;
            {
                var error = $root.AlarmEvent.verify(message.alarmEvent);
                if (error)
                    return "alarmEvent." + error;
            }
        }
        return null;
    };

    /**
     * Creates a MessageBody message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MessageBody
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MessageBody} MessageBody
     */
    MessageBody.fromObject = function fromObject(object) {
        if (object instanceof $root.MessageBody)
            return object;
        var message = new $root.MessageBody();
        switch (object.dataType) {
        case "Heartbeat":
        case 0:
            message.dataType = 0;
            break;
        case "EBoxInfo":
        case 1:
            message.dataType = 1;
            break;
        case "EBoxInfoList":
        case 2:
            message.dataType = 2;
            break;
        case "AlarmEvent":
        case 3:
            message.dataType = 3;
            break;
        }
        if (object.mid != null)
            message.mid = String(object.mid);
        if (object.heartbeat != null) {
            if (typeof object.heartbeat !== "object")
                throw TypeError(".MessageBody.heartbeat: object expected");
            message.heartbeat = $root.Heartbeat.fromObject(object.heartbeat);
        }
        if (object.eBoxInfo != null) {
            if (typeof object.eBoxInfo !== "object")
                throw TypeError(".MessageBody.eBoxInfo: object expected");
            message.eBoxInfo = $root.EBoxInfo.fromObject(object.eBoxInfo);
        }
        if (object.eBoxInfoList != null) {
            if (typeof object.eBoxInfoList !== "object")
                throw TypeError(".MessageBody.eBoxInfoList: object expected");
            message.eBoxInfoList = $root.EBoxInfoList.fromObject(object.eBoxInfoList);
        }
        if (object.alarmEvent != null) {
            if (typeof object.alarmEvent !== "object")
                throw TypeError(".MessageBody.alarmEvent: object expected");
            message.alarmEvent = $root.AlarmEvent.fromObject(object.alarmEvent);
        }
        return message;
    };

    /**
     * Creates a plain object from a MessageBody message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MessageBody
     * @static
     * @param {MessageBody} message MessageBody
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MessageBody.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.dataType = options.enums === String ? "Heartbeat" : 0;
            object.mid = "";
        }
        if (message.dataType != null && message.hasOwnProperty("dataType"))
            object.dataType = options.enums === String ? $root.MessageBody.DataType[message.dataType] : message.dataType;
        if (message.mid != null && message.hasOwnProperty("mid"))
            object.mid = message.mid;
        if (message.heartbeat != null && message.hasOwnProperty("heartbeat")) {
            object.heartbeat = $root.Heartbeat.toObject(message.heartbeat, options);
            if (options.oneofs)
                object.dataBody = "heartbeat";
        }
        if (message.eBoxInfo != null && message.hasOwnProperty("eBoxInfo")) {
            object.eBoxInfo = $root.EBoxInfo.toObject(message.eBoxInfo, options);
            if (options.oneofs)
                object.dataBody = "eBoxInfo";
        }
        if (message.eBoxInfoList != null && message.hasOwnProperty("eBoxInfoList")) {
            object.eBoxInfoList = $root.EBoxInfoList.toObject(message.eBoxInfoList, options);
            if (options.oneofs)
                object.dataBody = "eBoxInfoList";
        }
        if (message.alarmEvent != null && message.hasOwnProperty("alarmEvent")) {
            object.alarmEvent = $root.AlarmEvent.toObject(message.alarmEvent, options);
            if (options.oneofs)
                object.dataBody = "alarmEvent";
        }
        return object;
    };

    /**
     * Converts this MessageBody to JSON.
     * @function toJSON
     * @memberof MessageBody
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MessageBody.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * DataType enum.
     * @name MessageBody.DataType
     * @enum {number}
     * @property {number} Heartbeat=0 Heartbeat value
     * @property {number} EBoxInfo=1 EBoxInfo value
     * @property {number} EBoxInfoList=2 EBoxInfoList value
     * @property {number} AlarmEvent=3 AlarmEvent value
     */
    MessageBody.DataType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Heartbeat"] = 0;
        values[valuesById[1] = "EBoxInfo"] = 1;
        values[valuesById[2] = "EBoxInfoList"] = 2;
        values[valuesById[3] = "AlarmEvent"] = 3;
        return values;
    })();

    return MessageBody;
})();

$root.Heartbeat = (function() {

    /**
     * Properties of a Heartbeat.
     * @exports IHeartbeat
     * @interface IHeartbeat
     * @property {string|null} [deviceId] Heartbeat deviceId
     */

    /**
     * Constructs a new Heartbeat.
     * @exports Heartbeat
     * @classdesc Represents a Heartbeat.
     * @implements IHeartbeat
     * @constructor
     * @param {IHeartbeat=} [properties] Properties to set
     */
    function Heartbeat(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Heartbeat deviceId.
     * @member {string} deviceId
     * @memberof Heartbeat
     * @instance
     */
    Heartbeat.prototype.deviceId = "";

    /**
     * Creates a new Heartbeat instance using the specified properties.
     * @function create
     * @memberof Heartbeat
     * @static
     * @param {IHeartbeat=} [properties] Properties to set
     * @returns {Heartbeat} Heartbeat instance
     */
    Heartbeat.create = function create(properties) {
        return new Heartbeat(properties);
    };

    /**
     * Encodes the specified Heartbeat message. Does not implicitly {@link Heartbeat.verify|verify} messages.
     * @function encode
     * @memberof Heartbeat
     * @static
     * @param {IHeartbeat} message Heartbeat message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Heartbeat.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
        return writer;
    };

    /**
     * Encodes the specified Heartbeat message, length delimited. Does not implicitly {@link Heartbeat.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Heartbeat
     * @static
     * @param {IHeartbeat} message Heartbeat message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Heartbeat.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Heartbeat message from the specified reader or buffer.
     * @function decode
     * @memberof Heartbeat
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Heartbeat} Heartbeat
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Heartbeat.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Heartbeat();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.deviceId = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Heartbeat message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Heartbeat
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Heartbeat} Heartbeat
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Heartbeat.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Heartbeat message.
     * @function verify
     * @memberof Heartbeat
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Heartbeat.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.deviceId != null && message.hasOwnProperty("deviceId"))
            if (!$util.isString(message.deviceId))
                return "deviceId: string expected";
        return null;
    };

    /**
     * Creates a Heartbeat message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Heartbeat
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Heartbeat} Heartbeat
     */
    Heartbeat.fromObject = function fromObject(object) {
        if (object instanceof $root.Heartbeat)
            return object;
        var message = new $root.Heartbeat();
        if (object.deviceId != null)
            message.deviceId = String(object.deviceId);
        return message;
    };

    /**
     * Creates a plain object from a Heartbeat message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Heartbeat
     * @static
     * @param {Heartbeat} message Heartbeat
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Heartbeat.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.deviceId = "";
        if (message.deviceId != null && message.hasOwnProperty("deviceId"))
            object.deviceId = message.deviceId;
        return object;
    };

    /**
     * Converts this Heartbeat to JSON.
     * @function toJSON
     * @memberof Heartbeat
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Heartbeat.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Heartbeat;
})();

$root.EBoxInfo = (function() {

    /**
     * Properties of a EBoxInfo.
     * @exports IEBoxInfo
     * @interface IEBoxInfo
     * @property {number|null} [pid] EBoxInfo pid
     * @property {string|null} [projectName] EBoxInfo projectName
     * @property {number|null} [areaId] EBoxInfo areaId
     * @property {string|null} [areaName] EBoxInfo areaName
     * @property {string|null} [deviceId] EBoxInfo deviceId
     * @property {string|null} [deviceName] EBoxInfo deviceName
     * @property {string|null} [platform] EBoxInfo platform
     * @property {boolean|null} [online] EBoxInfo online
     */

    /**
     * Constructs a new EBoxInfo.
     * @exports EBoxInfo
     * @classdesc Represents a EBoxInfo.
     * @implements IEBoxInfo
     * @constructor
     * @param {IEBoxInfo=} [properties] Properties to set
     */
    function EBoxInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * EBoxInfo pid.
     * @member {number} pid
     * @memberof EBoxInfo
     * @instance
     */
    EBoxInfo.prototype.pid = 0;

    /**
     * EBoxInfo projectName.
     * @member {string} projectName
     * @memberof EBoxInfo
     * @instance
     */
    EBoxInfo.prototype.projectName = "";

    /**
     * EBoxInfo areaId.
     * @member {number} areaId
     * @memberof EBoxInfo
     * @instance
     */
    EBoxInfo.prototype.areaId = 0;

    /**
     * EBoxInfo areaName.
     * @member {string} areaName
     * @memberof EBoxInfo
     * @instance
     */
    EBoxInfo.prototype.areaName = "";

    /**
     * EBoxInfo deviceId.
     * @member {string} deviceId
     * @memberof EBoxInfo
     * @instance
     */
    EBoxInfo.prototype.deviceId = "";

    /**
     * EBoxInfo deviceName.
     * @member {string} deviceName
     * @memberof EBoxInfo
     * @instance
     */
    EBoxInfo.prototype.deviceName = "";

    /**
     * EBoxInfo platform.
     * @member {string} platform
     * @memberof EBoxInfo
     * @instance
     */
    EBoxInfo.prototype.platform = "";

    /**
     * EBoxInfo online.
     * @member {boolean} online
     * @memberof EBoxInfo
     * @instance
     */
    EBoxInfo.prototype.online = false;

    /**
     * Creates a new EBoxInfo instance using the specified properties.
     * @function create
     * @memberof EBoxInfo
     * @static
     * @param {IEBoxInfo=} [properties] Properties to set
     * @returns {EBoxInfo} EBoxInfo instance
     */
    EBoxInfo.create = function create(properties) {
        return new EBoxInfo(properties);
    };

    /**
     * Encodes the specified EBoxInfo message. Does not implicitly {@link EBoxInfo.verify|verify} messages.
     * @function encode
     * @memberof EBoxInfo
     * @static
     * @param {IEBoxInfo} message EBoxInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EBoxInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.pid != null && Object.hasOwnProperty.call(message, "pid"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pid);
        if (message.projectName != null && Object.hasOwnProperty.call(message, "projectName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.projectName);
        if (message.areaId != null && Object.hasOwnProperty.call(message, "areaId"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.areaId);
        if (message.areaName != null && Object.hasOwnProperty.call(message, "areaName"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.areaName);
        if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.deviceId);
        if (message.deviceName != null && Object.hasOwnProperty.call(message, "deviceName"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.deviceName);
        if (message.platform != null && Object.hasOwnProperty.call(message, "platform"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.platform);
        if (message.online != null && Object.hasOwnProperty.call(message, "online"))
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.online);
        return writer;
    };

    /**
     * Encodes the specified EBoxInfo message, length delimited. Does not implicitly {@link EBoxInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof EBoxInfo
     * @static
     * @param {IEBoxInfo} message EBoxInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EBoxInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a EBoxInfo message from the specified reader or buffer.
     * @function decode
     * @memberof EBoxInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {EBoxInfo} EBoxInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EBoxInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EBoxInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.pid = reader.int32();
                break;
            case 2:
                message.projectName = reader.string();
                break;
            case 3:
                message.areaId = reader.int32();
                break;
            case 4:
                message.areaName = reader.string();
                break;
            case 5:
                message.deviceId = reader.string();
                break;
            case 6:
                message.deviceName = reader.string();
                break;
            case 7:
                message.platform = reader.string();
                break;
            case 8:
                message.online = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a EBoxInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof EBoxInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {EBoxInfo} EBoxInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EBoxInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a EBoxInfo message.
     * @function verify
     * @memberof EBoxInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    EBoxInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.pid != null && message.hasOwnProperty("pid"))
            if (!$util.isInteger(message.pid))
                return "pid: integer expected";
        if (message.projectName != null && message.hasOwnProperty("projectName"))
            if (!$util.isString(message.projectName))
                return "projectName: string expected";
        if (message.areaId != null && message.hasOwnProperty("areaId"))
            if (!$util.isInteger(message.areaId))
                return "areaId: integer expected";
        if (message.areaName != null && message.hasOwnProperty("areaName"))
            if (!$util.isString(message.areaName))
                return "areaName: string expected";
        if (message.deviceId != null && message.hasOwnProperty("deviceId"))
            if (!$util.isString(message.deviceId))
                return "deviceId: string expected";
        if (message.deviceName != null && message.hasOwnProperty("deviceName"))
            if (!$util.isString(message.deviceName))
                return "deviceName: string expected";
        if (message.platform != null && message.hasOwnProperty("platform"))
            if (!$util.isString(message.platform))
                return "platform: string expected";
        if (message.online != null && message.hasOwnProperty("online"))
            if (typeof message.online !== "boolean")
                return "online: boolean expected";
        return null;
    };

    /**
     * Creates a EBoxInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof EBoxInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {EBoxInfo} EBoxInfo
     */
    EBoxInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.EBoxInfo)
            return object;
        var message = new $root.EBoxInfo();
        if (object.pid != null)
            message.pid = object.pid | 0;
        if (object.projectName != null)
            message.projectName = String(object.projectName);
        if (object.areaId != null)
            message.areaId = object.areaId | 0;
        if (object.areaName != null)
            message.areaName = String(object.areaName);
        if (object.deviceId != null)
            message.deviceId = String(object.deviceId);
        if (object.deviceName != null)
            message.deviceName = String(object.deviceName);
        if (object.platform != null)
            message.platform = String(object.platform);
        if (object.online != null)
            message.online = Boolean(object.online);
        return message;
    };

    /**
     * Creates a plain object from a EBoxInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof EBoxInfo
     * @static
     * @param {EBoxInfo} message EBoxInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    EBoxInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.pid = 0;
            object.projectName = "";
            object.areaId = 0;
            object.areaName = "";
            object.deviceId = "";
            object.deviceName = "";
            object.platform = "";
            object.online = false;
        }
        if (message.pid != null && message.hasOwnProperty("pid"))
            object.pid = message.pid;
        if (message.projectName != null && message.hasOwnProperty("projectName"))
            object.projectName = message.projectName;
        if (message.areaId != null && message.hasOwnProperty("areaId"))
            object.areaId = message.areaId;
        if (message.areaName != null && message.hasOwnProperty("areaName"))
            object.areaName = message.areaName;
        if (message.deviceId != null && message.hasOwnProperty("deviceId"))
            object.deviceId = message.deviceId;
        if (message.deviceName != null && message.hasOwnProperty("deviceName"))
            object.deviceName = message.deviceName;
        if (message.platform != null && message.hasOwnProperty("platform"))
            object.platform = message.platform;
        if (message.online != null && message.hasOwnProperty("online"))
            object.online = message.online;
        return object;
    };

    /**
     * Converts this EBoxInfo to JSON.
     * @function toJSON
     * @memberof EBoxInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    EBoxInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EBoxInfo;
})();

$root.EBoxInfoList = (function() {

    /**
     * Properties of a EBoxInfoList.
     * @exports IEBoxInfoList
     * @interface IEBoxInfoList
     * @property {Array.<IEBoxInfo>|null} [eBoxInfos] EBoxInfoList eBoxInfos
     */

    /**
     * Constructs a new EBoxInfoList.
     * @exports EBoxInfoList
     * @classdesc Represents a EBoxInfoList.
     * @implements IEBoxInfoList
     * @constructor
     * @param {IEBoxInfoList=} [properties] Properties to set
     */
    function EBoxInfoList(properties) {
        this.eBoxInfos = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * EBoxInfoList eBoxInfos.
     * @member {Array.<IEBoxInfo>} eBoxInfos
     * @memberof EBoxInfoList
     * @instance
     */
    EBoxInfoList.prototype.eBoxInfos = $util.emptyArray;

    /**
     * Creates a new EBoxInfoList instance using the specified properties.
     * @function create
     * @memberof EBoxInfoList
     * @static
     * @param {IEBoxInfoList=} [properties] Properties to set
     * @returns {EBoxInfoList} EBoxInfoList instance
     */
    EBoxInfoList.create = function create(properties) {
        return new EBoxInfoList(properties);
    };

    /**
     * Encodes the specified EBoxInfoList message. Does not implicitly {@link EBoxInfoList.verify|verify} messages.
     * @function encode
     * @memberof EBoxInfoList
     * @static
     * @param {IEBoxInfoList} message EBoxInfoList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EBoxInfoList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.eBoxInfos != null && message.eBoxInfos.length)
            for (var i = 0; i < message.eBoxInfos.length; ++i)
                $root.EBoxInfo.encode(message.eBoxInfos[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified EBoxInfoList message, length delimited. Does not implicitly {@link EBoxInfoList.verify|verify} messages.
     * @function encodeDelimited
     * @memberof EBoxInfoList
     * @static
     * @param {IEBoxInfoList} message EBoxInfoList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EBoxInfoList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a EBoxInfoList message from the specified reader or buffer.
     * @function decode
     * @memberof EBoxInfoList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {EBoxInfoList} EBoxInfoList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EBoxInfoList.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EBoxInfoList();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.eBoxInfos && message.eBoxInfos.length))
                    message.eBoxInfos = [];
                message.eBoxInfos.push($root.EBoxInfo.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a EBoxInfoList message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof EBoxInfoList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {EBoxInfoList} EBoxInfoList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EBoxInfoList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a EBoxInfoList message.
     * @function verify
     * @memberof EBoxInfoList
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    EBoxInfoList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.eBoxInfos != null && message.hasOwnProperty("eBoxInfos")) {
            if (!Array.isArray(message.eBoxInfos))
                return "eBoxInfos: array expected";
            for (var i = 0; i < message.eBoxInfos.length; ++i) {
                var error = $root.EBoxInfo.verify(message.eBoxInfos[i]);
                if (error)
                    return "eBoxInfos." + error;
            }
        }
        return null;
    };

    /**
     * Creates a EBoxInfoList message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof EBoxInfoList
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {EBoxInfoList} EBoxInfoList
     */
    EBoxInfoList.fromObject = function fromObject(object) {
        if (object instanceof $root.EBoxInfoList)
            return object;
        var message = new $root.EBoxInfoList();
        if (object.eBoxInfos) {
            if (!Array.isArray(object.eBoxInfos))
                throw TypeError(".EBoxInfoList.eBoxInfos: array expected");
            message.eBoxInfos = [];
            for (var i = 0; i < object.eBoxInfos.length; ++i) {
                if (typeof object.eBoxInfos[i] !== "object")
                    throw TypeError(".EBoxInfoList.eBoxInfos: object expected");
                message.eBoxInfos[i] = $root.EBoxInfo.fromObject(object.eBoxInfos[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a EBoxInfoList message. Also converts values to other types if specified.
     * @function toObject
     * @memberof EBoxInfoList
     * @static
     * @param {EBoxInfoList} message EBoxInfoList
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    EBoxInfoList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.eBoxInfos = [];
        if (message.eBoxInfos && message.eBoxInfos.length) {
            object.eBoxInfos = [];
            for (var j = 0; j < message.eBoxInfos.length; ++j)
                object.eBoxInfos[j] = $root.EBoxInfo.toObject(message.eBoxInfos[j], options);
        }
        return object;
    };

    /**
     * Converts this EBoxInfoList to JSON.
     * @function toJSON
     * @memberof EBoxInfoList
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    EBoxInfoList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EBoxInfoList;
})();

$root.AlarmEvent = (function() {

    /**
     * Properties of an AlarmEvent.
     * @exports IAlarmEvent
     * @interface IAlarmEvent
     * @property {string|null} [jsonData] AlarmEvent jsonData
     */

    /**
     * Constructs a new AlarmEvent.
     * @exports AlarmEvent
     * @classdesc Represents an AlarmEvent.
     * @implements IAlarmEvent
     * @constructor
     * @param {IAlarmEvent=} [properties] Properties to set
     */
    function AlarmEvent(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AlarmEvent jsonData.
     * @member {string} jsonData
     * @memberof AlarmEvent
     * @instance
     */
    AlarmEvent.prototype.jsonData = "";

    /**
     * Creates a new AlarmEvent instance using the specified properties.
     * @function create
     * @memberof AlarmEvent
     * @static
     * @param {IAlarmEvent=} [properties] Properties to set
     * @returns {AlarmEvent} AlarmEvent instance
     */
    AlarmEvent.create = function create(properties) {
        return new AlarmEvent(properties);
    };

    /**
     * Encodes the specified AlarmEvent message. Does not implicitly {@link AlarmEvent.verify|verify} messages.
     * @function encode
     * @memberof AlarmEvent
     * @static
     * @param {IAlarmEvent} message AlarmEvent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AlarmEvent.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.jsonData != null && Object.hasOwnProperty.call(message, "jsonData"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.jsonData);
        return writer;
    };

    /**
     * Encodes the specified AlarmEvent message, length delimited. Does not implicitly {@link AlarmEvent.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AlarmEvent
     * @static
     * @param {IAlarmEvent} message AlarmEvent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AlarmEvent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AlarmEvent message from the specified reader or buffer.
     * @function decode
     * @memberof AlarmEvent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AlarmEvent} AlarmEvent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AlarmEvent.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AlarmEvent();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.jsonData = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AlarmEvent message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AlarmEvent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AlarmEvent} AlarmEvent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AlarmEvent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AlarmEvent message.
     * @function verify
     * @memberof AlarmEvent
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AlarmEvent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.jsonData != null && message.hasOwnProperty("jsonData"))
            if (!$util.isString(message.jsonData))
                return "jsonData: string expected";
        return null;
    };

    /**
     * Creates an AlarmEvent message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AlarmEvent
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AlarmEvent} AlarmEvent
     */
    AlarmEvent.fromObject = function fromObject(object) {
        if (object instanceof $root.AlarmEvent)
            return object;
        var message = new $root.AlarmEvent();
        if (object.jsonData != null)
            message.jsonData = String(object.jsonData);
        return message;
    };

    /**
     * Creates a plain object from an AlarmEvent message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AlarmEvent
     * @static
     * @param {AlarmEvent} message AlarmEvent
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AlarmEvent.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.jsonData = "";
        if (message.jsonData != null && message.hasOwnProperty("jsonData"))
            object.jsonData = message.jsonData;
        return object;
    };

    /**
     * Converts this AlarmEvent to JSON.
     * @function toJSON
     * @memberof AlarmEvent
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AlarmEvent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AlarmEvent;
})();

module.exports = $root;
